
        <lib-demande-remboursement
        [fileLimit]="fileLimit"
        [fileMaxSize]="fileMaxSize"
        [pjRequired]="pjRequired"
        [fileAccept]="fileAccept"
        [messageRequired]="messageRequired"
        [configuration]="configuration"
        [fileNamePattern]="fileNamePattern">
        </lib-demande-remboursement>
